<template>
  <router-view name="membertype" v-bind:key="$route.path"></router-view>
</template>

<script>
  export default {
    name: "MemberType",
  };
</script>
